<template>
	<div>
		<input
			class="input"
			type="checkbox"
			:id="filterValue"
			:value="filterValue"
			@change="handleChange"
			@focus="isFocused = true"
			@blur="isFocused = false"
			:checked="isSelected && !clearSelectedFilters"
		/>
		<label :for="filterValue" class="label-wrapper">
			<div :class="[{ iconWrapperFocused: isFocused }, 'icon-wrapper']">
				<icon-base
					:class="[{ iconFocused: isFocused }, 'icon']"
					:iconName="filterValue"
					:id="filterValue + '-icon'"
					:iconColor="
						filterValue === 'Alcohol' ? 'white' : 'currentColor'
					"
				>
					<component :is="icon" :strokeColor="strokeColor" />
				</icon-base>
			</div>
			<div
				:class="
					isSelected && !clearSelectedFilters
						? 'filter-label-selected'
						: 'filter-label'
				"
			>
				{{ label }}
				<i
					v-if="isSelected && !clearSelectedFilters"
					class="far fa-times-circle clear-filter"
					:title="'Click to clear ' + label + ' filter.'"
				></i>
			</div>
		</label>
	</div>
</template>

<script>
import Asian from "./icons/IconAsian.vue";
import Alcohol from "./icons/IconAlcohol.vue";
import BBQ from "./icons/IconBbq.vue";
import Breakfast from "./icons/IconBreakfast.vue";
import Burgers from "./icons/IconBurgers.vue";
import Chinese from "./icons/IconChinese.vue";
import Indian from "./icons/IconIndian.vue";
import Italian from "./icons/IconItalian.vue";
import Mediterranean from "./icons/IconMediterranean.vue";
import Mexican from "./icons/IconMexican.vue";
import Pizza from "./icons/IconPizza.vue";
import Vegan from "./icons/IconVegan.vue";
import Vegetarian from "./icons/IconVegetarian.vue";

import IconBase from "./IconBase.vue";

export default {
	name: "CategoryFilter",
	model: {
		prop: "modelValue",
		event: "change"
	},
	props: {
		label: {
			type: String,
			required: true
		},
		icon: {
			type: String,
			required: true,
			validator: value => {
				return (
					[
						"Asian",
						"Alcohol",
						"BBQ",
						"Breakfast",
						"Burgers",
						"Chinese",
						"Indian",
						"Italian",
						"Mediterranean",
						"Mexican",
						"Pizza",
						"Vegan",
						"Vegetarian"
					].indexOf(value) !== -1
				);
			}
		},
		filterValue: {
			type: String
		},
		modelValue: {
			default: false
		},
		clearSelectedFilters: { type: Boolean }
	},
	components: {
		IconBase,
		Asian,
		Alcohol,
		Breakfast,
		BBQ,
		Burgers,
		Chinese,
		Indian,
		Italian,
		Mediterranean,
		Mexican,
		Pizza,
		Vegan,
		Vegetarian
	},
	computed: {
		isSelected: function() {
			return this.filterValue === this.modelValue ? true : false;
		},
		strokeColor: function() {
			if (
				(this.filterValue === "Alcohol" && this.isSelected) ||
				(this.filterValue === "Alcohol" && this.isFocused)
			) {
				return "#f1560f";
			} else {
				return "#1e83b4";
			}
		}
	},
	data: function() {
		return {
			isFocused: false
		};
	},
	methods: {
		handleChange(event) {
			let isSelected = event.target.checked;
			let newValue = "";
			if (isSelected) {
				newValue = this.filterValue;
			}
			this.$emit("change", newValue);
		}
	}
};
</script>

<style lang="scss" scoped>
.label-wrapper {
	display: flex;
	flex-direction: column;
	align-items: center;
	cursor: pointer;

	input[type="checkbox"]:checked + &,
	&:hover,
	&:focus {
		.icon-wrapper {
			background-color: $gray_4;
		}

		.icon {
			color: $tomato;
		}
	}
}

.icon-wrapper {
	width: 40px;
	height: 40px;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-bottom: 5px;

	@media (min-width: $mobilePortrait) {
		width: 65px;
		height: 65px;
	}

	@media (min-width: $tabletPortrait) {
		width: 85px;
		height: 85px;
	}
}

.icon {
	color: $royal;
	width: 30px;
	height: 30px;

	@media (min-width: $mobilePortrait) {
		width: 40px;
		height: 40px;
	}

	@media (min-width: $tabletPortrait) {
		width: 57px;
		height: 57px;
	}
}

.filter-label {
	font-size: 1.1rem;
	font-weight: 700;
	text-align: center;
}

.filter-label-selected {
	font-size: 1.3rem;
	font-weight: 700;
	text-align: center;
	border: 2px solid #f3f3f3;
	background-color: #f3f3f3;
	padding: 3px;
	border-radius: 15.5px;
}

.input {
	border: 0;
	clip: rect(0 0 0 0);
	height: 1px;
	margin: -1px;
	overflow: hidden;
	padding: 0;
	position: absolute;
	width: 1px;
}

.iconWrapperFocused {
	background-color: $gray_4;
}

.iconFocused {
	color: $tomato;
}
</style>